import { useEffect } from 'react';

const useObserver = (...ids) => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          const target = entry.target as HTMLElement;
          if (entry.isIntersecting) {
            target.style.transition = 'opacity 1s';
            target.style.opacity = '1';
          } else {
            target.style.opacity = '0';
          }
        });
      },
      {
        root: null,
        rootMargin: '-300px 0px -300px 0px',
      }
    );

    const targets = ids.map(id => document.getElementById(`${id}`)).filter(Boolean);

    targets.forEach(target => {
      if (target) {
        observer.observe(target);
      }
    });

    return () => {
      targets.forEach(target => {
        if (target) {
          target.style.transition = 'opacity 1s';
          target.style.opacity = '0';
          observer.unobserve(target);
        }
      });
    };
  }, ids);
};

export default useObserver;
